import { splitTestReminderName } from '@shared/configChanges'

export interface UnstartedSplitTest {
  pid: string
  resource_type: string
  resource_id: string
  status: string
  started_at: string | null
  reminder_dismissed?: boolean
}

export interface UnstartedReminder {
  pid: string
  name: string
  resourceType: string
  resourceId: string
}

/**
 * Draft tests that still need a person to review and start them.
 * Flow tests show only while that flow is open. A test whose flow, question
 * or offer is gone is omitted, so the bar never says "Unknown flow".
 */
export function unstartedSplitTestReminders(
  tests: readonly UnstartedSplitTest[],
  config: Parameters<typeof splitTestReminderName>[1] | null | undefined,
  flowId: string | null
): UnstartedReminder[] {
  if (!config) {
    return []
  }

  const reminders: UnstartedReminder[] = []
  for (const test of tests) {
    if (test.status !== 'draft' || test.started_at !== null || test.reminder_dismissed === true) {
      continue
    }
    if (test.resource_type === 'flow' && test.resource_id !== flowId) {
      continue
    }
    const name = splitTestReminderName(test, config)
    if (!name) {
      continue
    }
    reminders.push({
      pid: test.pid,
      name,
      resourceType: test.resource_type,
      resourceId: test.resource_id
    })
  }
  return reminders
}
